module.exports = __webpack_public_path__ + "img/banner-ru20x40.65f0a483.jpg";